import { Action } from '@ngrx/store';
import { DatosNiss } from 'src/app/models/SicarMap/DatosNiss.model';


export const GET_DATA_NISS = '[BUSQUEDA] Get DATA Niss';
export const GET_DATANISS_SUCCESS = '[BUSQUEDA] Get DATANISS Succes';
export const GET_DATANISS_FAILURE = '[BUSQUEDA] Get DATANISS Failure';
export const VISIBLE_DATANISS = '[BUSQUEDA] Visible DATANISS';
export const HIDDEN_DATANISS = '[BUSQUEDA] HIDDEN DATANISS';


export class GetDataNissAction implements Action {
  readonly type = GET_DATA_NISS;
  constructor(public Niss: number) {}
}
export class GetDataNissSuccesAction implements Action {
  readonly type = GET_DATANISS_SUCCESS;
  constructor(public datos: DatosNiss) {}
}
export class GetDataNissFailureAction implements Action {
  readonly type = GET_DATANISS_FAILURE;
  constructor(public error: any) {
  }
}

export class VisibleDataNissAction implements Action {
  readonly type = VISIBLE_DATANISS;
  constructor() {}
}

export class HiddenDataNissAction implements Action {
  readonly type = HIDDEN_DATANISS;
  constructor() {}
}

export type DataNissActions =
  | GetDataNissAction
  | GetDataNissSuccesAction
  | GetDataNissFailureAction
  | VisibleDataNissAction
  | HiddenDataNissAction;
